export enum ConfigTab {
  Storage = 'Storage',
  RecycleBin = 'RecycleBin',
  Classification = 'Classification',
  Permissions = 'Permissions',
}
